const action = {
    TRANS_ADD:'TRANS_ADD',
    TRANS_UPDATE: 'TRANS_UPDATE',
    TRANS_BULK_UPDATE: 'TRANS_BULK_UPDATE',
    TRANS_API_SUCCESS: 'TRANS_API_SUCCESS',
    TRANS_LIST: 'TRANS_LIST',
    TRANS_LIST_SHOW: 'TRANS_LIST_SHOW',
    TRANS_LIST_CLIENT: 'TRANS_LIST_CLIENT',
    TRANS_FETCH_ID:'TRANS_FETCH_ID',
    TRANS_FETCH_LIST_ID:'TRANS_FETCH_LIST_ID',
    PAYMENT_LIST:'PAYMENT_LIST',
    PAYMENT_API_SUCCESS: 'PAYMENT_API_SUCCESS',
    UNMATCHPAYMENT_LIST: 'UNMATCHPAYMENT_LIST',
    MATCH_PAYMENT:'MATCH_PAYMENT',

    transAdd:( history,dataObj) => ({ //Action creator function
      type: action.TRANS_ADD, //Action
     payload: {history,  dataObj } //pass payload to action, we should pass as little data to action
   }),
    transList: (readFilter, page) => ({ //Action creator function
        type: action.TRANS_LIST, //Action
        payload: { readFilter, page } //pass payload to action, we should pass as little data to action
    }),
    transListShow: (readFilter, page) => ({ //Action creator function
      type: action.TRANS_LIST_SHOW, //Action
      payload: { readFilter, page } //pass payload to action, we should pass as little data to action
  }),
    // transUpdate: (dataObj) => ({ //Action creator function
    //     type: action.TRANS_UPDATE, //Action
    //     payload: { dataObj } //pass payload to action, we should pass as little data to action
    // }),
    transUpdate: (history, transPojo) => ({
      type: action.TRANS_UPDATE,
      payload: { history, transPojo }
    }),
    transBulkUpdate: (history, transPojo) => ({
      type: action.TRANS_BULK_UPDATE,
      payload: { history, transPojo }
    }),
    transApiSuccess: (data, message, success) => ({
        type: action.TRANS_API_SUCCESS,
        data,
        message,
        success
    }),
    transfetchBYId:(listid)=>({
        type: action.TRANS_FETCH_ID,
        payload:{listid}
      }),
      transListById: (data,message,success) => ({
       type: action.TRANS_FETCH_LIST_ID,
       data,
       message,
       success
     }),
     paymentList: (readFilter, page) => ({ 
      type: action.PAYMENT_LIST, 
      payload: { readFilter, page } 
  }),
  paymentApiSuccess: (data, message, success) => ({
    type: action.PAYMENT_API_SUCCESS,
    data,
    message,
    success
}),
unMatchPayment: (readFilter,match, p_page, t_page) => ({ 
  type: action.UNMATCHPAYMENT_LIST, 
  payload: { readFilter,match, p_page,t_page } 
}),
matchPayment: (history, transPojo) => ({
  type: action.MATCH_PAYMENT,
  payload: { history, transPojo }
}),


};
export default action;